import request from "@/utils/request";

export function searchQRCode(params) {
    return request({
        url: "/api/services/app/Barcoding/SearchQRCode",
        method: "get",
        params
    });
}

export function syncBarcode(data) {
    return request({
        url: "/api/services/app/Barcoding/SyncBarcodes",
        method: "post",
        data
    });
}

export function syncSeedProductionBarcode(data) {
    return request({
        url: "/api/services/app/Barcoding/SyncSeedProductionBarcodes",
        method: "post",
        data
    });
}

export function printQRCodeImages(data) {
    return request({
        url: "/api/services/app/Barcoding/PrintQRCodeImages",
        method: "post",
        data
    });
}

export function printStorageQRCodeImages(params) {
    return request({
        url: "/api/services/app/Barcoding/PrintStorageQRCodeImages",
        method: "get",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/barcoding.js